import { Redirect, Route, Switch, Router } from 'react-router-dom';
import { history } from '../store';
import Investors from '../components/investors';
import OnboardingRouter from '../components/onboarding/Router';
import MobileLogin from '../components/auth/MobileLogin';
import LoginOtp from '../components/auth/loginOtp';
import RedirectRoute from './RedirectRoute';
import ProtectedRoute from './ProtectedRoute';
import ApplicationRoutes from '../components/investors/routes';
import Profile from '../components/profile/index';
import ApplicationDetails from '../components/ApplicationDetails/index';
import { useEffect } from 'react';
import { useSnackbar, VariantType } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import InvestorRoutes, { EditApplication } from '../components/Investments/routes';
import UserManagementLayOut from '../components/userManagement/router';
import { USER_ROLES } from '../utils/constant';
import { FundsSetup } from '../components/FundsSetup';
import { RiskProfile } from '../components/RiskProfile';
import { AMCAdminsList } from '../components/AmcAdmins';
import ApplicationEsignList from '../components/ApplicationsEsignList';
import { CLEAR_GLOBAL_ERROR } from '../redux-store/types/auth';
import { useModal } from 'mui-modal-provider';
import SimpleDialog, { CommonLayout } from '../components/commonComponents';
import { focusLastSubmitTrigger } from '../lib/formik/SubmitButton';
import NonIndividualApplicationRoutes, {
  NonIndividualApplicationEdit,
} from '../components/NonIndividualInvestor/routes';
import Reports from '../components/Reports/reports';
import { NonIndividualApplicationDetail } from '../components/NonIndividualApplicationDetails';
import ConsentEmailApproveReject, {
  ConsentEmailApplicationsList,
  ConsentEmailApprove,
  ConsentEmailReject,
} from '../components/ConsentEmailComponent';
import adminSupport from '../components/adminSupport';
import LoginRequireRoute from './LoginRequireRoute';
import Dashboard from '../components/dashboard';
import InvestorDashboard from '../components/dashboard/investor-dashboard';
import InvestorDetails from '../components/dashboard/investor-details';
import TotalRmDetail from '../components/dashboard/total-rm-detail';
import BookSizeDetail from '../components/dashboard/book-size-details';
import NetSales from '../components/dashboard/net-sales';
import TotalRevenue from '../components/dashboard/total-revenue';
import GrossSales from '../components/dashboard/gross-sales';
import IndividualInvestor from '../components/dashboard/individual-investor';
import ProductDetails from '../components/dashboard/product-details';
import DirectEquity from '../components/dashboard/direct-equity/direct-equity';
import { getAnalystDetails, getRmDetails } from '../redux-store/actions/userManagement';
import PMS from '../components/dashboard/pms/pms';
import InvestorReportRoute from '../components/InvestorReport/routesReport';
import AIF from '../components/dashboard/aif';
import Bonds from '../components/dashboard/bonds/index';
import InvestorTransactions from '../components/dashboard/investor-transaction/investor-transactions';
import DashboardReportRoute from '../components/dashboard/Reports_Dashboard/routes';
import { formatDate, isModuleAllowed } from '../utils/utilityFunctions';
import RecommendedSchemes from '../components/dashboard/investor-transaction/recommended-schemes'
import Holding from '../components/dashboard/investor-transaction/holdings'
import STP_SWP from '../components/dashboard/investor-transaction/STP-SWP'
import SwitchComp from '../components/dashboard/investor-transaction/Switch'
import Redeem from '../components/dashboard/investor-transaction/Redeem'
import SIPLumpsum from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import SIP from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import InvestorProfileRouter from "../components/investorOverview/InvestorProfileRouter";
import IndividualFundDetails from '../components/investorOverview/fundDetails';
import InvestorLoginRouter from '../components/investorOverview/InvestorLoginRouter';
import InvestorRecommendations from '../components/investorOverview/InvestorRecommendations';
import { storeInvestorClientId, storeIwappId } from '../redux-store/actions/id';
import { getCartItemsCount, setCartItemsCount } from '../redux-store/actions/cart';
import { GetCartItemsCountResponseBody } from '../redux-store/types/cart';
import CategoryWiseActionItems from '../components/investorOverview/mutualFund/CategoryWiseActionItems';
import SidebarMFCategoryWiseBreakup from '../components/dashboard/SidebarMFCategoryWiseBreakup';
import ProductsRouter from '../components/products/productsRouter';
import JointHolderType from '../components/auth/JointHolderType';
import { getInvestorDetails } from '../redux-store/actions/investorProfile';
import { getBusinessDate, setNavbarInfo, setNavbarInfoLoading } from '../redux-store/actions/navbarInfo';
import { GetBusinessDateResponseBody } from '../redux-store/types/navbarInfo';
// import Analytics from '../components/analytics';
import FamilyProfileDetails from '../components/FamilyProfileDetails';
import AnalyticsRouter from '../components/analytics/analyticsRouter';
import OnBoardingDashBoard from '../components/OnBoardingDashboard/index'
import { getCurrencyInfo, setCurrencyInfo } from '../redux-store/actions/currencyInfo';
import { GetCurrencyInfoResponseBody } from '../redux-store/types/currencyInfo';
import OrderManagementRouter from '../components/orderManagement/orderManagementRouter';
import OrdersApproval from '../components/ordersApproval';
import OrderDetails from '../components/ordersApproval/orderDetails';
import PaymentsApproval from '../components/paymentsApproval';
import PaymentDetails from '../components/paymentsApproval/paymentDetails';
import SettlementApproval from '../components/settlementApproval';
import SettlementDetails from '../components/settlementApproval/settlementDetails';
import InvOnboardingRoutes from '../components/InvestorOnboarding/InvOnboardingRoutes';
import InvApplicationRoutes from '../components/InvestorOnboarding/InvApplicationRoutes';
import CartRouter from '../components/Cart/CartRouter';
import PaymentRouter from '../payment/paymentRouter';
import BseTradeSuccess from '../components/investorOverview/BseTradeSuccess';
import SelectRole from '../components/auth/SelectRole';
import { getCheckerDetails } from '../redux-store/actions/orderApproval';
import BanksRouter from '../components/banks/banksRouter';
import NomineeRouter from '../components/nominee/nomineeRouter';
import NomineeOptOutRouter from '../components/NomineeOptOut/Router';
import RiaReport from '../components/RiaFee/RiaReport';
import RiaDashboard from '../components/RiaFee/RiaDashboard';
import RiaFeeSetupRouter from '../components/RiaFee/RiaFeeSetup/RiaFeeSetupRouter';
import RiaSummary from '../components/RiaFee/RiaSummary';
import SecExclusionMgmtRouter from '../components/RiaFee/SecurityExclusionMgmt/SecExclusionMgmtRouter';
import KycApplications from '../components/KycApplications';
import ComplianceApprovalList from '../components/ComplianceApprovalList';
import ComplianceApplicationDetails from '../components/ComplianceApprovalList/ComplianceApplicationDetails';

// import Orders from '../components/dashboard/investor-transaction/orders'

function AppRoutes(): JSX.Element {
  const dispatch = useDispatch();
  const { toaster, message, severity } = useSelector((state: RootStateType) => state.toast);
  const { id: userId, role = '', token = '', diyInvestorOnboarding = false, diyInvestorOnboardingEdit = false, diyInvOnboardingPrev = false, subRole = "", permissions = [] } = useSelector((state: RootStateType) => state.auth);
  const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
  const { enqueueSnackbar } = useSnackbar();
  const { showModal, state: modalState } = useModal();
  const errorState = useSelector((store: RootStateType) => store.error);
  const { investorClientId = '', clientInterfaceCode, applicationId = '' } = useSelector((store: RootStateType) => store.id);
  useEffect(() => {
    toaster && enqueueSnackbar(message, { variant: severity as VariantType });
  }, [toaster]);

  useEffect(() => {
    if (errorState && Object.keys(modalState ?? {}).length === 0) {
      const { error = '' } = errorState;
      const { destroy } = showModal(SimpleDialog, {
        content: error,
        actions: [
          {
            label: 'OK',
            onClick: () => {
              destroy();
              dispatch({ type: CLEAR_GLOBAL_ERROR });
              //trigger to prevent focus on the submit button
              setTimeout(() => {
                focusLastSubmitTrigger();
              }, 0);
            },
          },
        ],
      });
    }
  }, [errorState]);

  useEffect(() => {
    const fetch = async () => {

      let navbarInfoData = {
        rmName: "",
        businessDate: "",
        company: "",
        environment: "",
        userRole: ""
      }

      try {
        const urlContent = window.location.pathname.split("/")
        if (urlContent[1] === 'payment-flow') return;

        // Currency and Business date API start

        if (token) {
          dispatch(setNavbarInfoLoading(true));

          const [getCurrencyInfoResponse, getBusinessDateResponse] = await Promise.allSettled([
            dispatch(getCurrencyInfo() as unknown as Promise<GetCurrencyInfoResponseBody>),
            dispatch(getBusinessDate() as unknown as Promise<GetBusinessDateResponseBody>)
          ])

          if (getCurrencyInfoResponse?.status === "fulfilled" && getCurrencyInfoResponse?.value?.isSuccess) {
            const currencyInfoDetails = getCurrencyInfoResponse?.value?.result as any;

            dispatch(setCurrencyInfo({
              locale: currencyInfoDetails?.locale ?? "en-IN",
              currencyCode: currencyInfoDetails?.currencyCode ?? "INR",
              currencySymbol: currencyInfoDetails?.currencySymbol ?? "20B9"
            }));
          }

          if (getBusinessDateResponse?.status === "fulfilled" && getBusinessDateResponse?.value?.isSuccess) {
            const businessDateResult = getBusinessDateResponse?.value?.result as any;
            const currentEnvironment = getBusinessDateResponse?.value?.environment ?? "";
            const currentCompany = businessDateResult?.companyName?.split(" ")[0] ?? "";

            navbarInfoData = {
              ...navbarInfoData,
              businessDate: businessDateResult?.businessDate ?? "",
              environment: currentEnvironment ?? "",
              company: currentCompany ?? ""
            }
          }
        }

        // Currency and Business date API end

        if (userId && [USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM, USER_ROLES.ONBOARDING_SPECIALIST, USER_ROLES.IA, USER_ROLES.AMCAPPROVER].includes(role)) {
          dispatch(setNavbarInfoLoading(true));

          const getRmDetailsResponse = (await dispatch(getRmDetails())) as unknown as any;

          if (getRmDetailsResponse) {
            dispatch(storeIwappId({ iwappRmId: getRmDetailsResponse?.iwappRmId }));

            navbarInfoData = {
              ...navbarInfoData,
              rmName: getRmDetailsResponse?.name ?? "",
              userRole: getRmDetailsResponse?.userRole ?? ""
            }
          }
        }

        if (userId && role === USER_ROLES.INVESTOR) {
          dispatch(setNavbarInfoLoading(true));

          const urlContent = window.location.pathname.split("/")

          if (!(urlContent[1] === "investment-details" && urlContent[3] === "application-details" && urlContent.length === 4)) {

            if (selectedPortfolio?.value) {

              const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                portfolioId: selectedPortfolio?.value
              })) as unknown as Promise<GetCartItemsCountResponseBody>)

              if (isSuccess) {
                dispatch(setCartItemsCount(cartItemsCount));
              }
            }
          }
        }
        if (userId && [USER_ROLES.ANALYST].includes(role)) {
          dispatch(setNavbarInfoLoading(true));

          const getAnalystDetailsResponse = (await dispatch(getAnalystDetails())) as unknown as any;

          if (getAnalystDetailsResponse) {
            dispatch(storeIwappId({ iwappRmId: getAnalystDetailsResponse?.analystId }));

            navbarInfoData = {
              ...navbarInfoData,
              rmName: getAnalystDetailsResponse?.name ?? "",
              userRole: getAnalystDetailsResponse?.userRole ?? ""
            }
          }
        }

        // if ([USER_ROLES.OPE, USER_ROLES.OPM].includes(role)) {
        //   const checkerDetailsRes = await (dispatch(getCheckerDetails()) as unknown as Promise<any>);

        //   dispatch(storeIwappId({ iwappRmId: checkerDetailsRes?.approverId }));

        //   navbarInfoData = {
        //     ...navbarInfoData,
        //     rmName: checkerDetailsRes?.name ?? "",
        //     userRole: checkerDetailsRes?.userRole ?? ""
        //   }
        // }
      } catch (error) {
        console.log("Error: ", error)
      } finally {
        dispatch(setNavbarInfo(navbarInfoData));
        dispatch(setNavbarInfoLoading(false));
      }
    }

    fetch()
  }, [userId, history.location.pathname]);


  const ScrollToTopOnPageChange = () => {

    useEffect(() => {
      const unlisten = history.listen(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page on route change
      });
      return () => {
        unlisten();
      };
    }, [history]);

    return null;
  };

  const getBaseRoute = () => {
    // if ([
    //   USER_ROLES.RM,
    //   USER_ROLES.DISTRIBUTOR,
    //   USER_ROLES.SUBDISTRIBUTOR,
    //   USER_ROLES.OPE,
    //   USER_ROLES.OPM
    // ].includes(role)) {
    if (![USER_ROLES.INVESTOR].includes(role) && isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" })) {
      // return '/applications';
      return '/dashboard';
    }
    else if ([USER_ROLES.AMCAPPROVER].includes(role) && isModuleAllowed({ value: "POAPaymentApproval", compareArr: permissions, objKey: "permissonCode" })) {
      return '/payments-approval';
    }
    else if (
      [
        USER_ROLES.TRUSTEE,
        USER_ROLES.FUND_MANAGER,
        USER_ROLES.POAAPPROVER,
        USER_ROLES.AMCAPPROVER,
      ].includes(role)
    ) {
      return '/applications-list';
    } else if ([USER_ROLES.AMC_ADMIN].includes(role)) {
      // return '/dashboard';
      return '/user-management';
    } else if ([USER_ROLES.INVESTOR].includes(role)) {
      // return '/dashboard';
      if (diyInvOnboardingPrev && applicationId) {
        return `/investor-onboarding-application-details/${applicationId}`;
      }
      if (diyInvestorOnboarding || diyInvestorOnboardingEdit) {
        return '/investor-onboarding-application/personal-details'
      }
      return '/investor-dashboard';
    } else if ([USER_ROLES.ANALYST].includes(role)) {
      return '/reports-download'
    }
    else {
      return '/applications';
    }
  };

  return (
    <Router history={history}>
      {ScrollToTopOnPageChange()}
      <Switch>
        <Route
          exact
          path="/"
          render={(props: any) => (
            <Redirect {...props} to={getBaseRoute()} from={props.location.pathname} />
          )}
        />
        <RedirectRoute path="/login" component={MobileLogin} title="Login" />
        <RedirectRoute path="/verify-otp" component={LoginOtp} title="Verify OTP" />
        <RedirectRoute path="/joint-holder" component={JointHolderType} title="Account Type" />
        <RedirectRoute path="/select-role" component={SelectRole} title="Select Role" />
        <RedirectRoute path="/investor-onboarding" component={InvOnboardingRoutes} title="Investor Onboarding" />
        <ProtectedRoute
          path="/bsetrade"
          component={BseTradeSuccess}
          acceptedRoles={[USER_ROLES.INVESTOR]}
          title="BSE Trade Success"
        />
        <ProtectedRoute path="/investor-onboarding-application" component={InvApplicationRoutes} acceptedRoles={[USER_ROLES.INVESTOR]} title="Investor Onboarding Application" />
        <ProtectedRoute path="/add-diy-joint-holder" component={InvOnboardingRoutes} acceptedRoles={[USER_ROLES.INVESTOR]} title="Add Joint Holder" />
        <ProtectedRoute
          path="/dashboard"
          component={Dashboard}
          title="Dashboard"
          // acceptedRoles={[USER_ROLES.RM]}
          // acceptedRoles={[
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.OPE,
          //   USER_ROLES.OPM
          // ]}
          customAuthorizationCheck={
            ![USER_ROLES.INVESTOR].includes(role) && isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" })
          }
        />
        {/* <ProtectedRoute path="/analytics" component={Analytics} acceptedRoles={[USER_ROLES.RM]} /> */}
        <ProtectedRoute
          path='/fundDetails'
          component={IndividualFundDetails}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
          title="Fund Details"
        />
        <Route path="/product">
          <Switch>
            <Route exact path="/product" render={() => <Redirect to="/product/mutual-fund" />} />
            <ProtectedRoute
              path="/product"
              component={ProductsRouter}
              // acceptedRoles={[USER_ROLES.RM, USER_ROLES.INVESTOR]}
              customAuthorizationCheck
              title="Product"
            />
          </Switch>
        </Route>
        {/* <Route path="/bank">
          <Switch>
            <Route exact path="/bank" render={() => <Redirect to="/bank/updateBank" />} />
            <ProtectedRoute
              path="/bank"
              component={BanksRouter}
              customAuthorizationCheck={
                isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" }) ||
                isModuleAllowed({ value: "OrderRecommend", compareArr: permissions, objKey: "permissonCode" })
              }
              title="Bank"
            />
          </Switch>
        </Route> */}
        {/* <Route path="/nominee">
          <Switch>
            <Route exact path="/nominee" render={() => <Redirect to="/nominee/updateNominee" />} />
            <ProtectedRoute
              path="/nominee"
              component={NomineeRouter}
              customAuthorizationCheck={
                isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" }) ||
                isModuleAllowed({ value: "OrderRecommend", compareArr: permissions, objKey: "permissonCode" })
              }
              title="Nominee"
            />
          </Switch>
        </Route> */}
        <Route path="/analytics">
          <Switch>
            <Route exact path="/analytics" render={() => <Redirect to="/analytics/mutual-fund-research" />} />
            <ProtectedRoute
              path="/analytics"
              component={AnalyticsRouter}
              // acceptedRoles={[USER_ROLES.RM]}
              moduleCode="AnalyticsDashboard"
              title="Analytics"
            />
          </Switch>
        </Route>
        <Route path="/orders">
          <Switch>
            <Route exact path="/orders" render={() => <Redirect to="/orders/order-dashboard" />} />
            <ProtectedRoute
              path="/orders"
              component={OrderManagementRouter}
              // acceptedRoles={[USER_ROLES.RM]}
              customAuthorizationCheck
              title="Orders"
            />
          </Switch>
        </Route>
        <ProtectedRoute
          path="/investors"
          component={InvestorDashboard}
          // acceptedRoles={[USER_ROLES.RM]}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
          title="Investors"
        />
        <ProtectedRoute
          path="/onboard-overview"
          component={OnBoardingDashBoard}
          // acceptedRoles={[USER_ROLES.RM]}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
          title="Onboarding Overview"
        />
        {/* <ProtectedRoute path="/joint-holder" component={JointHolderType} acceptedRoles={[USER_ROLES.INVESTOR]} /> */}
        <ProtectedRoute
          path="/investor-dashboard"
          component={InvestorLoginRouter}
          // acceptedRoles={[USER_ROLES.INVESTOR]}
          moduleCode="INVDashboard"
          title="Investor Dashboard"
        />
        <ProtectedRoute
          path="/investor-recommendations"
          component={InvestorRecommendations}
          acceptedRoles={[USER_ROLES.INVESTOR]}
          title="Investor Recommendations"
        />
        <ProtectedRoute
          path="/cart"
          component={CartRouter}
          // acceptedRoles={[USER_ROLES.INVESTOR]}
          moduleCode="MFOrders"
          title="Cart"
        />
        <ProtectedRoute
          path="/investor-details"
          component={InvestorDetails}
          // acceptedRoles={[USER_ROLES.RM]}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
          title="Investor Details"
        />
        <ProtectedRoute
          path="/total-rm-detail"
          component={TotalRmDetail}
          // acceptedRoles={[USER_ROLES.RM]}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
          title="Total RM Detail"
        />
        <ProtectedRoute
          path="/book-size-detail"
          component={BookSizeDetail}
          // acceptedRoles={[USER_ROLES.RM]}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
          title="Book Size Detail"
        />
        <ProtectedRoute path="/net-sales" component={NetSales} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="Net Sales" />
        <ProtectedRoute path="/total-revenue" component={TotalRevenue} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="Total Revenue" />
        <ProtectedRoute path="/investor-transactions" component={InvestorTransactions} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="Investor Transactions" />
        <ProtectedRoute path="/recommended-schemes" component={RecommendedSchemes} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="Recommended Schemes" />
        <ProtectedRoute path="/holdings" component={Holding} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="Holdings" />
        {/* <ProtectedRoute path="/orders" component={Orders} acceptedRoles={[USER_ROLES.RM]} /> */}
        <ProtectedRoute path="/SIP_Lumpsum" component={SIPLumpsum} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="SIP Lumpsum" />
        <ProtectedRoute path="/STP_SWP" component={STP_SWP} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="STP SWP" />
        <ProtectedRoute path="/Switch" component={SwitchComp} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="Switch" />
        <ProtectedRoute path="/Redeem" component={Redeem} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="Redeem" />

        <ProtectedRoute
          path="/gross-sales"
          component={GrossSales}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM
          ]}
          title="Gross Sales"
        />
        <ProtectedRoute
          path="/applications"
          component={Investors}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="APPL"
          title="Applications"
        />
        <ProtectedRoute
          path="/onboarding"
          component={OnboardingRouter}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="INVOnboard"
          title="Onboarding"
        />
        <ProtectedRoute
          path="/kyc-applications"
          component={KycApplications}
          moduleCode="INVOnboard"
        />
        <ProtectedRoute
          path="/compliance-approval"
          component={ComplianceApprovalList}
          title="Compliance Approval"
          moduleCode="complianceChecker"
        />
        <ProtectedRoute
          path="/compliance-application-details/:id"
          component={ComplianceApplicationDetails}
          moduleCode="complianceChecker"
          title="Compliance Application Details"
        />
        <ProtectedRoute
          path="/investor-profile/:investorId"
          component={InvestorProfileRouter}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="INVDashboard"
          title="Investor Profile"
        />
        <ProtectedRoute
          path="/family-profile/:familyId"
          component={FamilyProfileDetails}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Family Profile"
        />
        <ProtectedRoute
          path="/application"
          component={ApplicationRoutes}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
          title="Application"
        />
        <ProtectedRoute
          path="/non-individual-application"
          component={NonIndividualApplicationRoutes}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
          title="Non Individual Application"
        />
        <ProtectedRoute
          path="/profile"
          component={Profile}
          acceptedRoles={[
            USER_ROLES.IA,
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
          title="Profile"
        />
        <ProtectedRoute
          path="/application-details/:id"
          component={ApplicationDetails}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.POAAPPROVER,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="APPL"
          title="Application Details"
        />
        <ProtectedRoute
          path="/application-checker-details/edit-application"
          component={EditApplication}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
          // moduleCode="INVOnboard"
          title="Edit Application"
        />
        <ProtectedRoute
          path="/investor-onboarding-application-details/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.INVESTOR
          ]}
          title="Investor Onboarding Application Details"
        />
        <ProtectedRoute
          path="/funds-setup"
          component={FundsSetup}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          title="Funds Setup"
        />
        <ProtectedRoute
          path="/risk-profile"
          component={RiskProfile}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          title="Risk Profile"
        />
        <ProtectedRoute
          path="/amc-admins"
          component={AMCAdminsList}
          acceptedRoles={[USER_ROLES.SUPER_ADMIN, USER_ROLES.DISTRIBUTOR]}
          title="AMC Admins"
        />
        <ProtectedRoute
          path="/reports"
          component={Reports}
          // acceptedRoles={[USER_ROLES.RM, USER_ROLES.AMC_ADMIN, USER_ROLES.AMCAPPROVER]}
          moduleCode="OnboardReport"
          title="Reports"
        />
        <ProtectedRoute
          path="/applications-list"
          component={ApplicationEsignList}
          // acceptedRoles={[
          //   USER_ROLES.TRUSTEE,
          //   USER_ROLES.FUND_MANAGER,
          //   USER_ROLES.POAAPPROVER,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="APPL"
          title="Applications List"
        />
        <ProtectedRoute
          path="/orders-approval"
          component={OrdersApproval}
          moduleCode="POAOrderApproval"
          title="Orders Approval"
        />
        <ProtectedRoute
          path="/order-details"
          component={OrderDetails}
          moduleCode="POAOrderApproval"
          title="Order Details"
        />
        <ProtectedRoute
          path="/order-dashboard-details"
          component={OrderDetails}
          moduleCode="OrderDashboard"
          title="Order Dashboard Details"
        />
        <ProtectedRoute
          path="/payments-approval"
          component={PaymentsApproval}
          moduleCode="POAPaymentApproval"
          title="Payments Approval"
        />
        <ProtectedRoute
          path="/payment-details"
          component={PaymentDetails}
          moduleCode="POAPaymentApproval"
          title="Payment Details"
        />
        <ProtectedRoute
          path="/settlements-approval"
          component={SettlementApproval}
          moduleCode="settlementApproval" // NOTE (CONV-02): "settlementApproval" is the correct server-defined module code — intentionally camelCase, not following the "POA"-prefixed pattern of sibling routes.
          title="Settlement Approvals"
        />
        <ProtectedRoute
          path="/settlement-details"
          component={SettlementDetails}
          moduleCode="settlementApproval" // NOTE (CONV-02): same module code as above — confirmed correct.
          title="Settlement Details"
        />
        <ProtectedRoute
          path="/user-management"
          component={UserManagementLayOut}
          // acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          moduleCode="RML"
          title="User Management"
        />
        <ProtectedRoute
          path="/non-individual-application-details/:id"
          component={NonIndividualApplicationDetail}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="APPL"
          title="Non Individual Application Details"
        />
        <ProtectedRoute
          path="/non-individual-application-edit"
          component={NonIndividualApplicationEdit}
          acceptedRoles={[USER_ROLES.AMCAPPROVER]}
          title="Non Individual Application Edit"
        />
        <ProtectedRoute
          path="/application-preview/:id"
          component={ApplicationDetails}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
          title="Application Preview"
        />
        <ProtectedRoute
          path="/investor-onboarding-application-preview/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.INVESTOR,
          ]}
          title="Investor Onboarding Application Preview"
        />
        <ProtectedRoute
          path="/non-individual-application-preview/:id"
          component={NonIndividualApplicationDetail}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          // ]}
          moduleCode="INVOnboard"
          title="Non Individual Application Preview"
        />
        <Route path='/payment-flow' component={PaymentRouter} />
        <Route path='/nominee-opt-out' component={NomineeOptOutRouter} />
        <Route path="/investment-details" component={InvestorRoutes} />
        <Route path="/investor-consent/:verificationToken" component={ConsentEmailApproveReject} />
        <Route path="/investor-consent-approved" component={ConsentEmailApprove} />
        <Route path="/investor-consent-reject" component={ConsentEmailReject} />
        <ProtectedRoute
          path="/view-consent-email-list"
          component={ConsentEmailApplicationsList}
          // acceptedRoles={[
          //   USER_ROLES.AMC_ADMIN,
          //   USER_ROLES.RM,
          //   USER_ROLES.OPE,
          //   USER_ROLES.OPM,
          //   USER_ROLES.DISTRIBUTOR,
          //   USER_ROLES.SUBDISTRIBUTOR,
          //   USER_ROLES.AMCAPPROVER,
          // ]}
          moduleCode="INVOnboard"
          title="View Consent Email List"
        />
        <ProtectedRoute
          path="/admin-support"
          component={adminSupport}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          title="Admin Support"
        />
        <ProtectedRoute
          path="/ria-report"
          component={RiaReport}
          moduleCode="riaReport"
          title="RIA Report"
        />
        <ProtectedRoute
          path="/ria-dashboard"
          component={RiaDashboard}
          moduleCode="riaControlDashboard"
          title="RIA Dashboard"
        />
        <ProtectedRoute
          path="/ria-fee-setup"
          component={RiaFeeSetupRouter}
          moduleCode="riaFeeSetUp"
          title="RIA Fee Setup"
        />
        <ProtectedRoute
          path="/ria-summary"
          component={RiaSummary}
          moduleCode="riaSummary"
          title="RIA Summary"
        />
        <ProtectedRoute
          path="/security-exclusion-management"
          component={SecExclusionMgmtRouter}
          moduleCode="riaSecurityExclusionManagement"
          title="Security Exclusion Management"
        />
        <ProtectedRoute
          path="/ria-fee-setup"
          component={RiaFeeSetupRouter}
          moduleCode="riaFeeSetUp"
        />
        <ProtectedRoute
          path="/ria-summary"
          component={RiaSummary}
          moduleCode="riaSummary"
        />
        <ProtectedRoute
          path="/security-exclusion-management"
          component={SecExclusionMgmtRouter}
          moduleCode="riaSecurityExclusionManagement"
        />
        <Route path="/">
          <Switch>
            <ProtectedRoute
              exact
              path="/investor"
              component={IndividualInvestor}
              acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]}
              title="Investor"
            />
            {/* <ProtectedRoute
              path="/investor-reports"
              component={InvestorReportRoute}
              acceptedRoles={[USER_ROLES.RM]}
            /> */}
            <ProtectedRoute
              path="/investor-reports"
              component={InvestorReportRoute}
              // acceptedRoles={[USER_ROLES.INVESTOR]}
              moduleCode="INVReports"
              title="Transaction Reports"
            />
            <ProtectedRoute
              path="/reports-download"
              component={DashboardReportRoute}
              // acceptedRoles={[USER_ROLES.RM, USER_ROLES.AMC_ADMIN, USER_ROLES.ANALYST]}
              moduleCode="INVReports"
              title="Reports Download"
            />
            <ProtectedRoute
              path="/investor/mutual-fund"
              component={ProductDetails}
              acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]}
              title="Mutual Fund"
            />
            <ProtectedRoute
              path="/investor/direct-equity"
              component={DirectEquity}
              acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]}
              title="Direct Equity"
            />
            <ProtectedRoute path="/investor/pms" component={PMS} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="PMS" />
            <ProtectedRoute path="/investor/aif" component={AIF} acceptedRoles={[USER_ROLES.IA, USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM]} title="AIF" />
          </Switch>
        </Route>
        <LoginRequireRoute path="*" />
      </Switch>
    </Router>
  );
}

export default AppRoutes;
